module.exports = __webpack_public_path__ + "img/cc.ce0d110b.svg";